import React from "react";
import map from "lodash/map";
import moment from "moment";
import MetricsFoot from "../MetricsFoot";
import MetricsBackButton from "../metrics-back-button";
import set from "@rill/set";
import NavigationComponent from "../../calendar/components/NavigationComponent";
import SvgIcon from "../../../../parts/SvgIcon";
import { AthleteLinks } from "../../../../parts/athlete-links";
import { AthleteSelect } from "../../../../parts/inputs/athlete-select-new";
import getAvatarUrl from "../../../../utils/get-avatar-url";
import { ReportsBackHandler } from "../../calendar/components/ReportsBackHandler";

function View(props, { locals }) {
  const {
    listCustomMetrics,
    search,
    query,
    athlete: athleteObj,
    pathname,
    query: { athlete },
  } = locals;
  const organizationCoach = locals.query.organizationCoach || undefined;
  const organizationCoachParam = organizationCoach
    ? `&organizationCoach=${organizationCoach}`
    : "";
  return (
    <main role="reports-wrapper">
      <NavigationComponent
        query={query}
        pathName={"/athlete-portal/metrics"}
        text="Calendar Day View"
        classNames="mobile-hidden"
      />
      <div className="athlete-section-header only-show-mobile">
        <AthleteLinks
          athlete={athleteObj}
          pathName={pathname}
          classNames={"only-show-mobile"}
          query={query}
        />
        <div className="athlete-select dropdown-athlete">
          <div
            className="avatar"
            style={{
              backgroundImage: `url(${getAvatarUrl(athlete)})`,
            }}
          />
          <AthleteSelect locals={locals} />
        </div>
      </div>
      <article role="report-content" id="strength-metrics">
        <ReportsBackHandler
          title={"Strength Metrics"}
          locals={locals}
          customBackUrl={`/athlete-portal/metrics/${search}`}
        />
        <header>
          <hgroup className="metrics-title">
            <MetricsBackButton
              url={`/athlete-portal/metrics/${search}`}
              classNames="mobile-hidden"
            />
            <SvgIcon
              src="/img/new-icons/custom-metrics-ico.svg"
              className="metrics-icon mobile-hidden"
              noFilterOnLight={true}
            />
            <div>
              <SvgIcon
                src="/img/new-icons/custom-metrics-ico.svg"
                className="metrics-icon only-show-mobile"
                noFilterOnLight={true}
              />
              <h3>Custom Reports List</h3>
              <p className="p4 mobile-hidden">
                Analyze your training metrics with complete flexibility. Take
                any data point we track, and slice and dice it any way you want.
                Create custom reports, save them, and track what's important to
                you.
              </p>
            </div>
            <p className="p4 only-show-mobile">
              Analyze your training metrics with complete flexibility. Take any
              data point we track, and slice and dice it any way you want.
              Create custom reports, save them, and track what's important to
              you.
            </p>
          </hgroup>
          <hgroup>
            <a
              role="button"
              data-button-type="primary"
              className="add-new"
              href={`/athlete-portal/metrics/custom/edit?athlete=${athlete}${organizationCoachParam}`}
            >
              Create Custom Report
            </a>
          </hgroup>
        </header>
        <div className="CMR-Archive">
          {map(listCustomMetrics, (customMetric, i) => {
            return (
              <div className="item" key={customMetric._id}>
                <div className="name">{customMetric.name}</div>
                <div className="date">
                  {moment.utc(customMetric.date).format("MMM DD, YYYY")}
                </div>
                <a
                  className="link"
                  href={`/athlete-portal/metrics/custom/view/${customMetric._id}?athlete=${athlete}`}
                />
              </div>
            );
          })}
        </div>
        <MetricsFoot shareHref="/actions/refresh?modal[type]=share" />
      </article>
    </main>
  );
}

const List = (app) => {
  app.get(
    "/list",
    set("heading", "Custom Metrics Reports"),
    async ({ res, load, locals: { query } }) => {
      await load("listCustomMetrics", {
        reqSource: "metrics",
        proxyAthlete: query.athlete,
      });
      res.body = <View />;
    }
  );
};

export default List;
